module.exports = __webpack_public_path__ + "static/media/policyBenefits.0fe58ca4.svg";